import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

interface AIIndicatorChipProps {
  isCallActive: boolean;
}

export function AIIndicatorChip({ isCallActive }: AIIndicatorChipProps) {
  const [visible, setVisible] = useState(false);

  // Show chip 3 seconds after call becomes active
  useEffect(() => {
    if (isCallActive) {
      const timer = setTimeout(() => setVisible(true), 3000);
      return () => clearTimeout(timer);
    }
    setVisible(false);
  }, [isCallActive]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="inline-flex items-center gap-1.5 bg-[#333333]/80 backdrop-blur-sm border border-white/[0.08] rounded-full px-3 py-1"
        >
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-lime-400 opacity-50" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-lime-500" />
          </span>
          <Sparkles className="h-3 w-3 text-lime-400" />
          <span className="text-[11px] font-medium text-gray-300">AI Voice</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
